"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.challengeTeams = {
    ibm: {
        readableName: 'IBM',
        token: 'ibm',
    },
    lenovo: {
        readableName: 'Lenovo',
        token: 'lenovo',
    },
    mozilla: {
        readableName: 'Mozilla',
        token: 'mozilla',
    },
    sap: {
        readableName: 'SAP',
        token: 'sap',
    },
};
// For run-time checking.
exports.challengeTokens = ['pilot'];
exports.challengeTeamTokens = Object.values(exports.challengeTeams).map(team => team.token);
//# sourceMappingURL=challenge.js.map